'use client'

import { useEffect } from 'react'
import { ThemeProvider } from 'next-themes'
import { NextUIProvider } from '@nextui-org/react'
import { useRouter } from 'next/navigation'
import { defaultLocale } from '@/shared/config/i18n/config'

export function Providers({ children }: { children: React.ReactNode }) {
  const router = useRouter()

  useEffect(() => {
    // Устанавливаем русский язык при первой загрузке, если язык не выбран
    if (!document.cookie.includes('NEXT_LOCALE')) {
      document.cookie = `NEXT_LOCALE=${defaultLocale};path=/`
    }
  }, [])

  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="light"
      enableSystem={false}
      themes={['light', 'dark']}
    >
      <NextUIProvider navigate={router.push}>{children}</NextUIProvider>
    </ThemeProvider>
  )
}
